<template>
  <div>
    <b-container class="container-panel">
      <b-row align-v="end">
        <b-col cols="3">
          <img src="./assets/images/logoSmall.jpg"
               class="logo-margin"
               alt="Ambit Cares Logo"
               aria-label="Ambit Cares Logo" />
        </b-col>
        <b-col cols="9">
        </b-col>
      </b-row>
    </b-container>

    <b-container class="container-panel outlined-panel">
      <b-row>
        <b-col class="container-panel-heading">
          Navigation Error!
        </b-col>
      </b-row>
      <b-container>
        <b-row>
          <b-col cols="2">
            <font-awesome-icon icon="exclamation-circle"
                               size="3x"
                               style="color: red;">
            </font-awesome-icon>
          </b-col>
          <b-col cols="10">
            <span>
              You have arrived at this page in error.  Please press the button to return to the main AmbitCares page
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="9">
          </b-col>
          <b-col cols="3">
            <b-button class="btn btn-primary btn-lg btn-margin-narrow-aligned-right float-right make-space-above"
                      title="Return to AmbitCares"
                      aria-label="Return to AmbitCares"
                      @click="returnToAmbitCares">
              Return to AmbitCares
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-container>

  </div>
</template>

<script>
  import utilities from '../utilities';

  export default {
    name: 'Unexpected',

    data() {
      return {
        url: '',
      }
    },

    // -----------------------------------------------------------------------
    // The created method is part of the Vue.js lifecycle.
    // It gets called as the page is created. 
    // -----------------------------------------------------------------------
    created() {
      this.url = window.location.href;
    },

    methods: {
      returnToAmbitCares() {
        utilities.returnToAmbitCares();
      },
    },
  }

</script>

<style src="./assets/css/CommonVue.css" scoped>
</style>

<style scoped>
</style>
